<div style="text-align: center;margin-bottom: 5px;width: 100%;bottom: 0;margin-top: 100px;">
  <img src="/assets/logo-CNAHP.png" style="min-height: 100px;max-height: 200px;height: 100px;">
  <img src="/assets/logo-anpeip.png" style="min-height: 100px;max-height: 200px;height: 100px;">
  <img src="/assets/logo-afehp.png" style="min-height: 100px;max-height: 200px;height: 100px;">
  <img src="/assets/logo-LPPC.png" style="min-height: 100px;max-height: 200px;height: 100px;">
</div>